import { render, staticRenderFns } from "./OutgoingInvitations.vue?vue&type=template&id=6e631037&"
import script from "./OutgoingInvitations.vue?vue&type=script&lang=js&"
export * from "./OutgoingInvitations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports